import { InsuredData, SimulationColumnNamesMap, SimulationInsuredFieldsMap } from "./salud-pymes-insured-types";

export const simulationColumnNames: SimulationColumnNamesMap = {
  "CODIGO POSTAL": "postalCode",
  "FECHA DE NACIMIENTO (DD/MM/YYYY)": "birthDate",
  "GENERO (M/H)": "gender",
  "GS30 - DENTAL - (S/N)": "GS30",
  "GS99 - ACCIDENTES - CAPITAL": "GS99",
  "GS09 - INDEMNIZACION HOSPITALARIA - CAPITAL": "GS09",
};

export const simulationInsuredFields: SimulationInsuredFieldsMap = {
  postalCode: "CODIGO POSTAL",
  birthDate: "FECHA DE NACIMIENTO (DD/MM/YYYY)",
  gender: "GENERO (M/H)",
  GS30: "GS30 - DENTAL - (S/N)",
  GS99: "GS99 - ACCIDENTES - CAPITAL",
  GS09: "GS09 - INDEMNIZACION HOSPITALARIA - CAPITAL",
};

export const formatInsuredsCsv = (insuredData: InsuredData[]) => {
  const headers = Object.keys(simulationColumnNames);
  const rows = insuredData.map((insured: any) => {
    const row: { [key: string]: string } = {};
    row[simulationInsuredFields.postalCode] = insured.address.postalCode;
    row[simulationInsuredFields.birthDate] = insured.birthDate;
    row[simulationInsuredFields.gender] = insured.gender;

    insured.coverages.forEach((coverage: any) => {
      if (coverage.code === "GS30") {
        row[simulationInsuredFields.GS30] = coverage.checked ? "S" : "N";
      } else if (coverage.code === "GS99") {
        row[simulationInsuredFields.GS99] = coverage.capitalValue || "";
      } else if (coverage.code === "GS09") {
        row[simulationInsuredFields.GS09] = coverage.capitalValue || "";
      }
    });

    return row;
  });

  const EOL = "\r\n";
  const SEP = ";";
  const BOM = "\uFEFF";

  const csvContent =
    BOM +
    headers.join(SEP) +
    (rows.length ? EOL : "") +
    rows
      .map((row: any) =>
        headers.map((h) => `"${String(row[h] ? row[h] : "").replace(/"/g, '""')}"`).join(SEP)
      )
      .join(EOL);

  return csvContent;
};
